/* eslint-disable */
import type { BusinessFilter, OfferFilter } from "./filter.pb";
import type { SortBy } from "./sorting.pb";

export enum JoinCondition {
  /** JOIN_CONDITION_RETURN_ONLY - the join query will not affect the target entity in the results */
  JOIN_CONDITION_RETURN_ONLY = "JOIN_CONDITION_RETURN_ONLY",
  /** JOIN_CONDITION_AND - the join query will be added to the main query in conjunction with other filters */
  JOIN_CONDITION_AND = "JOIN_CONDITION_AND",
  /** JOIN_CONDITION_OR - the join query will be added to the main query in disjunction with other sub-queries */
  JOIN_CONDITION_OR = "JOIN_CONDITION_OR",
}

export interface JoinQuery {
  /** how the join query will be added to the main query */
  join_condition?: JoinCondition;
  /** the filter of the join entity */
  entity_filter?: EntityFilter;
  /** max number of matching join entities to return, zero means no need to return */
  max_results?: number;
  /** how to sort within the join query, default value will not apply any sorts, only SortByFields is supported */
  sort_by?: SortBy;
}

export interface EntityFilter {
  business_filter?: BusinessFilter | undefined;
  offer_filter?: OfferFilter | undefined;
}
